import React, { useCallback } from 'react';
import { SearchInput } from '@common-fe/common-fe';

import REGEXP from '@/common/regexp';
interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}
const InvoiceIDInput: React.FC<Props> = ({ value, onChange, disabled }) => {
  const handleChange = useCallback(
    (newValue: string) => {
      const formattedValue = newValue.replace(REGEXP.EXCLUDE_NUMBERS, '');
      onChange(formattedValue);
    },
    [onChange]
  );
  return (
    <SearchInput
      placeholder="Invoice ID"
      testId="report_invoice"
      value={value}
      disabled={disabled}
      onChange={handleChange}
    />
  );
};

export default InvoiceIDInput;
